module.exports = __webpack_public_path__ + "img/BarneyDines_140x140.ccd1e8c9.jpg";